// extracted by mini-css-extract-plugin
export default {"page":"AuthLoginPage_page__Nbvfm","container":"AuthLoginPage_container__jXgDE"};